import { render, staticRenderFns } from "./AllocationsDialog.vue?vue&type=template&id=5663c3aa&"
import script from "./AllocationsDialog.vue?vue&type=script&lang=js&"
export * from "./AllocationsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports